export const payment_success = {
  v: "4.8.0",
  meta: { g: "LottieFiles AE 3.0.0", a: "", k: "", d: "", tc: "" },
  fr: 60,
  ip: 0,
  op: 81,
  w: 96,
  h: 96,
  nm: "Success",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Shape Layer 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [48.312, 47.438, 0], ix: 2 },
        a: { a: 0, k: [-0.938, -1.062, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-14, -1.25],
                    [-4.938, 7.125],
                    [12.125, -9.25],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 8, ix: 5 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "tm",
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.05], y: [0] },
                t: 30,
                s: [0],
              },
              { t: 50, s: [100] },
            ],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false,
        },
      ],
      ip: 0,
      op: 180,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [48, 48, 0], ix: 2 },
        a: { a: 0, k: [44.125, -69.625, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 20,
              s: [0, 0, 100],
            },
            { t: 40, s: [100, 100, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [65.75, 65.75], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.529411764706, 0.407843167174, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [44.125, -69.625], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 180,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Shape Layer 1",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 20,
              s: [100],
            },
            { t: 60, s: [0] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [48, 48, 0], ix: 2 },
        a: { a: 0, k: [44.125, -69.625, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0], y: [1, 1, 1] },
              o: { x: [0.05, 0.05, 0.05], y: [0, 0, 0] },
              t: 20,
              s: [0, 0, 100],
            },
            { t: 60, s: [135, 135, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: { a: 0, k: [65.75, 65.75], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Ellipse Path 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [0, 0.529411764706, 0.407843167174, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 4, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [44.125, -69.625], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 180,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};

export const payment_fail = {
  nm: "07 - Error",
  ddd: 0,
  h: 500,
  w: 500,
  meta: { g: "@lottiefiles/toolkit-js 0.33.2" },
  layers: [
    {
      ty: 4,
      nm: "Red",
      sr: 1,
      st: 0,
      op: 144,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [-1, -0.25, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [249.00000000000003, 249.75, 0], ix: 2 },
        r: {
          a: 1,
          k: [
            { o: { x: 0.75, y: 0 }, i: { x: 0.25, y: 1 }, s: [180], t: 0 },
            { s: [0], t: 30 },
          ],
          ix: 10,
        },
        sa: { a: 0, k: 0 },
        o: {
          a: 1,
          k: [
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0.833, y: 0.833 },
              s: [0],
              t: 0,
            },
            { s: [100], t: 3 },
          ],
          ix: 11,
        },
      },
      ef: [],
      shapes: [
        {
          ty: "gr",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Group",
          nm: "Shape 1",
          ix: 1,
          cix: 2,
          np: 3,
          it: [
            {
              ty: "sh",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Shape - Group",
              nm: "Path 1",
              ix: 1,
              d: 1,
              ks: {
                a: 1,
                k: [
                  {
                    o: { x: 0.75, y: 0 },
                    i: { x: 0.25, y: 1 },
                    s: [
                      {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-1, -0.5],
                          [-1, -0.688],
                        ],
                      },
                    ],
                    t: 0,
                  },
                  {
                    s: [
                      {
                        c: false,
                        i: [
                          [0, 0],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-1, 63],
                          [-1, -63.5],
                        ],
                      },
                    ],
                    t: 30,
                  },
                ],
                ix: 2,
              },
            },
            {
              ty: "st",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Graphic - Stroke",
              nm: "Stroke 1",
              lc: 2,
              lj: 1,
              ml: 4,
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 28, ix: 5 },
              c: { a: 0, k: [1, 1, 1], ix: 3 },
            },
            {
              ty: "tr",
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [0, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
        {
          ty: "tm",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Filter - Trim",
          nm: "Trim Paths 1",
          ix: 2,
          e: { a: 0, k: 100, ix: 2 },
          o: { a: 0, k: 0, ix: 3 },
          s: {
            a: 1,
            k: [
              { o: { x: 0.75, y: 0 }, i: { x: 0.25, y: 1 }, s: [0], t: 21 },
              { s: [40], t: 45 },
            ],
            ix: 1,
          },
          m: 1,
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Circle_white",
      sr: 1,
      st: 7,
      op: 144,
      ip: 28,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0, 59, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0, y: 1 },
              s: [0, 0, 100],
              t: 28,
            },
            { s: [100, 100, 100], t: 43 },
          ],
          ix: 6,
        },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [-0.75, 63, 0], ix: 2 },
        r: { a: 0, k: 0, ix: 10 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100, ix: 11 },
      },
      ef: [],
      shapes: [
        {
          ty: "gr",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Group",
          nm: "Shape 1",
          ix: 1,
          cix: 2,
          np: 3,
          it: [
            {
              ty: "sh",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Shape - Group",
              nm: "Path 1",
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -7.732],
                    [7.732, 0],
                    [0, 7.732],
                    [-7.732, 0],
                  ],
                  o: [
                    [0, 7.732],
                    [-7.732, 0],
                    [0, -7.732],
                    [7.732, 0],
                  ],
                  v: [
                    [14, 0],
                    [0, 14],
                    [-14, 0],
                    [0, -14],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: "fl",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Graphic - Fill",
              nm: "Fill 1",
              c: { a: 0, k: [1, 1, 1], ix: 4 },
              r: 1,
              o: { a: 0, k: 100, ix: 5 },
            },
            {
              ty: "tr",
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [0, 59], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
      ],
      ind: 2,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Circle_black",
      sr: 1,
      st: 0,
      op: 144,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              o: { x: 0.167, y: 0.167 },
              i: { x: 0, y: 1 },
              s: [0, 0, 100],
              t: 0,
            },
            { s: [100, 100, 100], t: 30 },
          ],
          ix: 6,
        },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [250, 250, 0], ix: 2 },
        r: { a: 0, k: 0, ix: 10 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100, ix: 11 },
      },
      ef: [],
      shapes: [
        {
          ty: "gr",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Group",
          nm: "Shape 1",
          ix: 1,
          cix: 2,
          np: 3,
          it: [
            {
              ty: "sh",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Shape - Group",
              nm: "Path 1",
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -63.513],
                    [63.513, 0],
                    [0, 63.513],
                    [-63.513, 0],
                  ],
                  o: [
                    [0, 63.513],
                    [-63.513, 0],
                    [0, -63.513],
                    [63.513, 0],
                  ],
                  v: [
                    [115, 0],
                    [0, 115],
                    [-115, 0],
                    [0, -115],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: "fl",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Graphic - Fill",
              nm: "Fill 1",
              c: { a: 0, k: [0.8588, 0.6431, 0.2392], ix: 4 },
              r: 1,
              o: { a: 0, k: 100, ix: 5 },
            },
            {
              ty: "tr",
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [0, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
      ],
      ind: 3,
    },
  ],
  v: "5.4.2",
  fr: 48,
  op: 144,
  ip: 0,
  assets: [],
};

export const payment_loading = {
  nm: "loader-3dots",
  ddd: 0,
  h: 800,
  w: 800,
  meta: { g: "@lottiefiles/toolkit-js 0.26.1" },
  layers: [
    {
      ty: 4,
      nm: "#dot03",
      sr: 1,
      st: 6,
      op: 79,
      ip: 0,
      hd: false,
      ln: "dot03",
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0.583, y: 0 },
              i: { x: 0.6, y: 1 },
              s: [501.81399999999996, 439.774, 0],
              t: 8,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.4, y: 0 },
              i: { x: 0.599, y: 1 },
              s: [501.81399999999996, 379.774, 0],
              t: 25,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.58, y: 1 },
              s: [501.81399999999996, 479.774, 0],
              t: 44,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.58, y: 1 },
              s: [501.81399999999996, 429.774, 0],
              t: 57,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.5, y: 1 },
              s: [501.81399999999996, 445.774, 0],
              t: 69,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            { s: [501.81399999999996, 439.774, 0], t: 79 },
          ],
          ix: 2,
        },
        r: { a: 0, k: 0, ix: 10 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100, ix: 11 },
      },
      ef: [],
      shapes: [
        {
          ty: "gr",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Group",
          nm: "Group 1",
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: "sh",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Shape - Group",
              nm: "Path 1",
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -16.569],
                    [16.569, 0],
                    [0, 16.569],
                    [-16.569, 0],
                  ],
                  o: [
                    [0, 16.569],
                    [-16.569, 0],
                    [0, -16.569],
                    [16.569, 0],
                  ],
                  v: [
                    [30, 0],
                    [0, 30],
                    [-30, 0],
                    [0, -30],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: "fl",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Graphic - Fill",
              nm: "Fill 1",
              c: { a: 0, k: [1, 1, 1], ix: 4 },
              r: 1,
              o: { a: 0, k: 100, ix: 5 },
            },
            {
              ty: "tr",
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [0, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "#dot02",
      sr: 1,
      st: 3,
      op: 79,
      ip: 0,
      hd: false,
      ln: "dot02",
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0.583, y: 0 },
              i: { x: 0.513, y: 1 },
              s: [401.81399999999996, 439.774, 0],
              t: 4,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.474, y: 0 },
              i: { x: 0.575, y: 1 },
              s: [401.81399999999996, 379.774, 0],
              t: 20,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.58, y: 1 },
              s: [401.81399999999996, 479.774, 0],
              t: 39,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.58, y: 1 },
              s: [401.81399999999996, 429.774, 0],
              t: 53,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.5, y: 1 },
              s: [401.81399999999996, 445.774, 0],
              t: 65,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            { s: [401.81399999999996, 439.774, 0], t: 75 },
          ],
          ix: 2,
        },
        r: { a: 0, k: 0, ix: 10 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100, ix: 11 },
      },
      ef: [],
      shapes: [
        {
          ty: "gr",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Group",
          nm: "Group 1",
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: "sh",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Shape - Group",
              nm: "Path 1",
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -16.569],
                    [16.569, 0],
                    [0, 16.569],
                    [-16.569, 0],
                  ],
                  o: [
                    [0, 16.569],
                    [-16.569, 0],
                    [0, -16.569],
                    [16.569, 0],
                  ],
                  v: [
                    [30, 0],
                    [0, 30],
                    [-30, 0],
                    [0, -30],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: "fl",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Graphic - Fill",
              nm: "Fill 1",
              c: { a: 0, k: [1, 1, 1], ix: 4 },
              r: 1,
              o: { a: 0, k: 100, ix: 5 },
            },
            {
              ty: "tr",
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [0, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
      ],
      ind: 2,
    },
    {
      ty: 4,
      nm: "#dot01",
      sr: 1,
      st: 0,
      op: 79,
      ip: 0,
      hd: false,
      ln: "dot01",
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0.583, y: 0 },
              i: { x: 0.4, y: 1 },
              s: [301.814, 439.774, 0],
              t: 0,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.7, y: 0 },
              i: { x: 0.599, y: 1 },
              s: [301.814, 379.774, 0],
              t: 15,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.58, y: 1 },
              s: [301.814, 479.774, 0],
              t: 35,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.58, y: 1 },
              s: [301.814, 429.774, 0],
              t: 49,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            {
              o: { x: 0.333, y: 0 },
              i: { x: 0.5, y: 1 },
              s: [301.814, 445.774, 0],
              t: 61,
              ti: [0, 0, 0],
              to: [0, 0, 0],
            },
            { s: [301.814, 439.774, 0], t: 71 },
          ],
          ix: 2,
        },
        r: { a: 0, k: 0, ix: 10 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100, ix: 11 },
      },
      ef: [],
      shapes: [
        {
          ty: "gr",
          bm: 0,
          hd: false,
          mn: "ADBE Vector Group",
          nm: "Group 1",
          ix: 1,
          cix: 2,
          np: 2,
          it: [
            {
              ty: "sh",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Shape - Group",
              nm: "Path 1",
              ix: 1,
              d: 1,
              ks: {
                a: 0,
                k: {
                  c: true,
                  i: [
                    [0, -16.569],
                    [16.569, 0],
                    [0, 16.569],
                    [-16.569, 0],
                  ],
                  o: [
                    [0, 16.569],
                    [-16.569, 0],
                    [0, -16.569],
                    [16.569, 0],
                  ],
                  v: [
                    [30, 0],
                    [0, 30],
                    [-30, 0],
                    [0, -30],
                  ],
                },
                ix: 2,
              },
            },
            {
              ty: "fl",
              bm: 0,
              hd: false,
              mn: "ADBE Vector Graphic - Fill",
              nm: "Fill 1",
              c: { a: 0, k: [1, 1, 1], ix: 4 },
              r: 1,
              o: { a: 0, k: 100, ix: 5 },
            },
            {
              ty: "tr",
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              sk: { a: 0, k: 0, ix: 4 },
              p: { a: 0, k: [0, 0], ix: 2 },
              r: { a: 0, k: 0, ix: 6 },
              sa: { a: 0, k: 0, ix: 5 },
              o: { a: 0, k: 100, ix: 7 },
            },
          ],
        },
      ],
      ind: 3,
    },
  ],
  v: "5.7.4",
  fr: 60,
  op: 60,
  ip: 0,
  assets: [],
};
